import { HTTP } from '../../utils'
import { getItem } from '../../storage'

export const populateCareers = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('career/all')
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareerInformation = (career, institutionId) => {
  return getItem('token').then(token => {
    return HTTP(token).get('career/information/' + career + '/' + institutionId)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareerResults = (cipCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('majorMinor/careers/' + cipCode)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareerResultsUsingSocCode = (socCode) => {
  return getItem('token').then(token => {
    return HTTP(token).get('career/relatedCareers/' + socCode)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getAllBookmarks = () => {
  let url = 'bookmark/user/all'
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getBookmarks = (name, page, count) => {
  return getItem('token').then(token => {
    return HTTP(token).get('bookmark/user?name=' + name + '&page=' + page + '&count=' + count)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const createBookmark = (bookmark) => {
  return getItem('token').then(token => {
    return HTTP(token).put('bookmark', bookmark)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const deleteBookmark = (uuid) => {
  var url = '/bookmark/' + uuid
  return getItem('token').then(token => {
    return HTTP(token).delete(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareerUsingUuid = (uuid) => {
  var url = '/career/' + uuid
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getProgramGuideUsingUuid = (uuid) => {
  var url = '/programguide/' + uuid
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getProgramCreditProgress = (streamId, programId, recalculate) => {
  var url = '/progress/credit/' + streamId + '/' + programId
  if (recalculate) {
    url += '/update'
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareerSkillProgress = (streamId, careerId, recalculate) => {
  var url = '/progress/skill/' + streamId + '/' + careerId
  if (recalculate) {
    url += '/update'
  }
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getFastestGrowingCareers = () => {
  var url = '/career/fastestGrowingCareers?count=5'
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getCareersWithLargestEmployment = () => {
  var url = '/career/careersWithLargestEmployment?count=5'
  return getItem('token').then(token => {
    return HTTP(token).get(url)
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getReport = (query) => {
  return getItem('token').then(token => {
    return HTTP(token).get('/alumniReport/report?' + query)
    .then(response => {
      return response.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}

export const getInstitutionCareers = () => {
  return getItem('token').then(token => {
    return HTTP(token).get('institutionCareer/all')
    .then(res => {
      return res.data
    })
    .catch(e => {
      console.log(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/app/explore/api.js